import ContactUs from "../components/contactus/ContactUs";
import Layout from "../layout/Layout";

const ContactUsPage = () => {
  return (
    <Layout>
      <ContactUs />
    </Layout>
  );
};

export default ContactUsPage;
